import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";

// import { useLocation } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";

import Chat from "../../Chat/Chat";
import Misc from '../Misc/Misc'

import EmployeeMaster from "../EmployeeDetails/EmployeeDetails";
import EmployeeNew from "../EmployeeDetails/EmployeeNew";
import EmployeeView from "../EmployeeDetails/EmployeeView";
import AllowanceView from "../AllowanceMaster/Allowance";
import ShiftView from "../ShiftMaster/Shift";
import TeamView from "../TeamMaster/Team";
import HolidayView from "../HolidayMaster/Holiday";
import LeaveNorms from '../Norms/LeaveNorms';
import LeaveNormsCreate from '../Norms/LeaveNormsCreate';
import LeaveNormsView from '../Norms/LeaveNormsView';

import DailyAttendance from '../Transactions/DailyAttendance';
import SalaryNorms from '../Norms/SalaryNorms';
import SalaryNormsCreate from '../Norms/SalaryNormCreate';
import SalaryNormsView from '../Norms/SalaryNormView';
import AdvanceForm from '../Norms/AdvanceForm';
import AdvanceFormCreate from '../Norms/AdvanceFormCreate';
import AdvanceFormView from '../Norms/AdvanceFormView';

import SalaryProcessing from '../Transactions/SalaryProcessing';
import EmployeeData from '../SalaryWadges/EmployeeData';
import AttandanceData from '../SalaryWadges/AttandanceData';

const FieldDataS = (fieldProps) => {
  // const location = useLocation();

  // console.log("Current path:", location.pathname);
  return (
    <div className={classes["Fields"]}>
      <Routes>
      <Route path="/norms/leave-norms"  element={ <LeaveNorms /> }/>

      <Route path="/norms/leave-norms-create" element ={<LeaveNormsCreate  /> }/>
      
       <Route path="/norms/leave-norms-view/:id" element ={<LeaveNormsView  /> }/> 
      

      <Route path="/norms/salary-norms" element={<SalaryNorms />} />
                 
      <Route path="/norms/salary-norms-create" element ={<SalaryNormsCreate />}/>
      <Route path="/norms/salary-norms-view/:id" element ={<SalaryNormsView   /> }/> 

      <Route path="/norms/salary-advance" element={<AdvanceForm  />}/>
      <Route path="/norms/advance-form-create" element={<AdvanceFormCreate  />}/>
      <Route path="/norms/advance_form_view/:id" element ={<AdvanceFormView   /> }/> 
      
      {/* <Route path="/transactions/leave" element ={<Leave />}/> */}

      <Route path="/transactions/salary-processing" element={<SalaryProcessing />} />
            
      <Route path="/salarywadges/employee-data" element  ={<EmployeeData />}/>

      <Route path="/salarywadges/attandance-data" element  ={<AttandanceData />}/> 

      <Route path="/dashboard" element={<Dashboard />} />

    
       

      
        <Route
          path="/transection/employee"
          element={<EmployeeMaster />}
        />
        <Route
          path="/allowanceMaster/allowance-detalis"
          element={<AllowanceView />}
        />
        <Route
          path="/shiftMaster/shift-details"
          element={<ShiftView />}
        />
        <Route
          path="/teamMaster/team-details"
          element={<TeamView />}
        />
        <Route
          path="/HolidayMaster/holiday-details"
          element={<HolidayView />}
        />
        <Route
          path="/transection/employee-create"
          element={<EmployeeNew />}
        />
        <Route
          path="/transaction/employee-details-view/:id"
          element={<EmployeeView />}
        />
      

       
          <Route path="/misc/:id1" 
           element={<Misc /> }
           />


       
        <Route path="/transaction/Purchase/Chatbot" element={<Chat />} />
      
        <Route path="/transactions/daily-attendance" element={<DailyAttendance />} />
                 
      </Routes>
    </div>
  );
};

export default FieldDataS;

